/**
 * Certificate Service
 * Handles certificate definition and user certificate API calls
 */

import axiosInstance, { apiRequest } from '../axiosInstance';
import { CERTIFICATE_DEFINITION_ENDPOINTS, USER_CERTIFICATE_ENDPOINTS, buildQueryString } from '../endpoints';

const certificateService = {
  // Certificate Definitions
  getDefinitions: async (params = {}) => {
    const queryString = buildQueryString(params);
    return apiRequest(() =>
      axiosInstance.get(`${CERTIFICATE_DEFINITION_ENDPOINTS.LIST}${queryString}`)
    );
  },

  getDefinitionById: async (id) => {
    return apiRequest(() =>
      axiosInstance.get(CERTIFICATE_DEFINITION_ENDPOINTS.GET_BY_ID(id))
    );
  },

  createDefinition: async (data) => {
    return apiRequest(() =>
      axiosInstance.post(CERTIFICATE_DEFINITION_ENDPOINTS.CREATE, data)
    );
  },

  updateDefinition: async (id, data) => {
    return apiRequest(() =>
      axiosInstance.put(CERTIFICATE_DEFINITION_ENDPOINTS.UPDATE(id), data)
    );
  },

  deleteDefinition: async (id) => {
    return apiRequest(() =>
      axiosInstance.delete(CERTIFICATE_DEFINITION_ENDPOINTS.DELETE(id))
    );
  },

  // User Certificates (own profile)
  getMyCertificates: async () => {
    return apiRequest(() =>
      axiosInstance.get(USER_CERTIFICATE_ENDPOINTS.MY)
    );
  },

  addMyCertificate: async (data) => {
    return apiRequest(() =>
      axiosInstance.post(USER_CERTIFICATE_ENDPOINTS.ADD_MY, data)
    );
  },

  updateMyCertificate: async (id, data) => {
    return apiRequest(() =>
      axiosInstance.put(USER_CERTIFICATE_ENDPOINTS.UPDATE_MY(id), data)
    );
  },

  deleteMyCertificate: async (id) => {
    return apiRequest(() =>
      axiosInstance.delete(USER_CERTIFICATE_ENDPOINTS.DELETE_MY(id))
    );
  },

  // Admin: view any user's certs
  getUserCertificates: async (userId) => {
    return apiRequest(() =>
      axiosInstance.get(USER_CERTIFICATE_ENDPOINTS.USER(userId))
    );
  },

  // Compliance check
  getWorkOrderCompliance: async (workOrderId) => {
    return apiRequest(() =>
      axiosInstance.get(USER_CERTIFICATE_ENDPOINTS.WORK_ORDER_COMPLIANCE(workOrderId))
    );
  },

  // Org-wide user certificate summary
  getOrgUsersCertificateSummary: async () => {
    return apiRequest(() =>
      axiosInstance.get(USER_CERTIFICATE_ENDPOINTS.ORG_SUMMARY)
    );
  },
};

export default certificateService;
